import { Button, Center, Group, Stack, Text, Title } from "@mantine/core";

import { IconAlertTriangle } from "@tabler/icons-react";
import { SecureTokenManager } from "@utils/auth/secureTokenManager";
import { getPreferredTestModeUrl } from "@utils/testModeStorage";
import { useTranslation } from "react-i18next";

interface ErrorFallbackProps {
  resetError: () => void;
}

export default function ErrorFallback({ resetError }: ErrorFallbackProps) {
  const { t } = useTranslation();
  const isAuthenticated = SecureTokenManager.isAuthenticated();
  const homePath = isAuthenticated ? getPreferredTestModeUrl() : "/";

  return (
    <Center mih={isAuthenticated ? "70vh" : "100vh"} px="md">
      <Stack align="center" gap="xs" maw={480}>
        <IconAlertTriangle size={64} stroke={1.5} color="var(--mantine-color-dimmed)" />
        <Title order={2} ta="center">
          {t("errorBoundary.title")}
        </Title>
        <Text ta="center" c="dimmed">
          {t("errorBoundary.description")}
        </Text>
        <Group mt="md">
          <Button variant="default" onClick={resetError}>
            {t("errorBoundary.tryAgain")}
          </Button>
          <Button component="a" href={homePath}>
            {isAuthenticated ? t("errorBoundary.goToDashboard") : t("errorBoundary.goHome")}
          </Button>
        </Group>
      </Stack>
    </Center>
  );
}
